import { Button, ButtonProps } from "@mui/material";
import Spinner from "../Loading/Spinner";

type LoadingButtonProps = ButtonProps & {
  loading: boolean;
};
const LoadingButton = ({
  loading,
  children,
  startIcon,
  sx,
  ...props
}: LoadingButtonProps) => {
  return (
    <Button
      {...props}
      sx={{
        ...sx,
        opacity: loading ? 0.5 : 1,
        pointerEvents: loading ? "none" : "initial",
      }}
      startIcon={
        <span>
          {loading ? <Spinner size="1em" color="inherit" /> : startIcon}
        </span>
      }
    >
      {children}
    </Button>
  );
};

export default LoadingButton;
